export default __webpack_public_path__ + "static/media/rgs_main_mobile_small.de4cd7b3.jpg";